var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#67678B",
    opacity: 0.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.067 3.986c-.094-.094-.221-.148-.354-.148-.133 0-.26.053-.354.147L3.437 14.91c-.195.195-.195.512 0 .707l4.948 4.948c.195.195.512.195.707 0L20.009 9.648c.195-.195.195-.51 0-.706l-4.942-4.956zM2.43 16.8c-.128-.128-.315-.176-.489-.127-.174.049-.308.188-.351.364L.084 23.314c-.04.17.01.347.133.47.124.121.301.171.47.132l6.272-1.5c.176-.042.316-.176.365-.35.049-.175 0-.362-.128-.49L2.43 16.8zM23.2 2.924L21.077.8c-.976-.974-2.556-.974-3.532 0l-1.418 1.417c-.195.195-.195.512 0 .707l4.95 4.949c.195.195.512.195.707 0L23.2 6.454c.973-.976.973-2.554 0-3.53z",
    transform: "translate(-1055 -342) translate(1055 342)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b56bff21.svg";
export { ForwardRef as ReactComponent };